<template>
	<div class="card buscas">
		<div class="card-header">
			<svg width="1em" height="1em" viewBox="0 0 11 24">
				<polygon points="0,0 11,12 0,24 6,12" fill="currentcolor"/>
			</svg>
			{{title}}
		</div>
		<div class="card-body collapse">
			<form :action="action">
				<label class="sr-only" for="search">{{placeholder}}</label>

				<div class="input-group">
					<input type="text" name="search" id="search" :placeholder="placeholder" class="form-control"/>

					<div class="input-group-append">
						<button class="btn btn-search">
							<i class="fa fa-search"></i>
							<span class="sr-only">{{btnText}}</span>
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
export default{
	name: 'Busca',
	props: [
		'action',
		'placeholder',
		'title',
		'btn-text'
	]
}
</script>


// WEBPACK FOOTER //
// src/assets/vue/components/Sidebar/Buscas.vue